var _path, _path2, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCertificateBackgroundDecor = function SvgCertificateBackgroundDecor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 276,
    viewBox: "0 0 602 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M584 118.663L584.946 115.131C585.232 114.064 586.329 113.431 587.396 113.717L588.996 114.146C590.063 114.432 591.16 113.798 591.446 112.731L591.875 111.131C592.161 110.064 593.257 109.431 594.324 109.717L595.925 110.146C596.991 110.432 598.088 109.798 598.374 108.731L599.321 105.199",
    stroke: "#FF5858",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M351 261.2L351.946 264.732C352.232 265.799 353.329 266.432 354.396 266.146L355.996 265.718C357.063 265.432 358.16 266.065 358.446 267.132L358.875 268.732C359.161 269.799 360.257 270.432 361.324 270.146L362.925 269.718C363.991 269.432 365.088 270.065 365.374 271.132L366.321 274.664",
    stroke: "#61D5EE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 52.1992,
    r: 3,
    stroke: "#61D5EE",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 127.199,
    x2: 10,
    y2: 147.199,
    stroke: "#FF5858",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 137.199,
    x2: -1.09278e-7,
    y2: 137.199,
    stroke: "#FF5858",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.1339,
    y1: 130.208,
    x2: 2.99175,
    y2: 144.35,
    stroke: "#FF5858",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.25,
    x2: 20,
    y2: -1.25,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 16.25 145.324)",
    stroke: "#FF5858",
    strokeWidth: 2.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    y1: 0.199219,
    x2: 517,
    y2: 16.1992,
    stroke: "#7B60FA",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 525,
    y1: 8.19922,
    x2: 509,
    y2: 8.19922,
    stroke: "#7B60FA",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 522.707,
    y1: 2.60554,
    x2: 511.393,
    y2: 13.9193,
    stroke: "#7B60FA",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 16,
    y2: -1,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 522 14.6992)",
    stroke: "#7B60FA",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCertificateBackgroundDecor);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";